import React, {useEffect, useState} from 'react'
import { Form, FormControl, Tab, Tabs } from 'react-bootstrap'
import { createUser, getPositions, getActiveUser } from '../../api/api';
import Swal from 'sweetalert2';
import { json, useNavigate } from 'react-router-dom';
import { DeleteForever } from '@mui/icons-material';
import statesData from './states.json'
import { FaCheck, FaPlus } from 'react-icons/fa';
const CreateUser = () => {
	const navigate = useNavigate()
	const [data, setData ] = useState({ });
	const [password, setPassword] = useState('');
	const [image, setImage] = useState();
	const [imageStatus, setImageStatus] = useState(false);
	const [states, setStates] = useState(statesData);
	const [lgas, setLgas] = useState();
	const [userDocs, setUserDocs] = useState([]);
	const [docDetail, setDocDetail] = useState({title: null, school: null});
	const [docFile, setDocFile] = useState(null);
	const [votees, setVotees] = useState(null);
	const [positions, setPositions] = useState(null);
	const [defaultTab, setDefaultTab] = useState('userDetails');
	const [userId, setUserId] = useState(null); // user id need for documents upload
	const [activeUser, setActiveUser] = useState(null);
    const handleChange = (e) => {
        setData({ ...data, [e.target.name] : e.target.value});
    }
	const credentials = [
		{
			name: 'FSLC'
		},
		{
			name: 'SSCE'
		},
		{
			name: 'NCE'
		},
		{
			name: 'ND'
		},
		{
			name: 'HND'
		},
		{
			name: 'Degree (Bsc, Bed, BTech etc)'
		},
		{
			name: 'Professional Certificate'
		},
		{
			name: 'PGD'
		},
		{
			name: 'MSC'
		},
		{
			name: 'PHD'
		}
	]
	const otherDocuments= [
		"quarrantor form one",
		"quarrantor form two",
		"attestation form"
	]
	
    const handleSubmit = async (e) => {
      e.preventDefault()
	//   window.start_load();
      // console.log('form submitted.');
	  let formId = document.getElementById('newUser');
      const formData = new FormData(formId);
	  const process = async () => {
		password == 'default' && formData.append('password', '0000');
		formData.append('file', image[0]);
		formData.append('state',data.state);
		formData.append('position', data.position);
		formData.append('access_type', data.access_type);
		formData.append('category', data.category);
		formData.delete('cpassword');
		// console.log(formData);
		const response = await createUser(formData);
		// console.log(response);
		if(response.success){
			// Swal.fire('Success', response.message, 'success');///
			setPassword('');
			setImage();
			setImageStatus(!imageStatus);
			setDefaultTab('credentials')
			e.target.reset();
			setUserId(response.userId); // User id need for documents upload
			localStorage.setItem('userId', response.userId);
			Swal.fire({
				title: 'Successful',
				icon:"success",
				text: response.message,
				closeButtonHtml: `<button className="btn btn-color"> Close </button>` 
			})
			
		}else{
			// Swal.fire('Failed', response.message, 'error')
			Swal.fire({
				title: 'Failed',
				icon:"error",
				text: response.message,
				// showCloseButton: true,
				showConfirmButton: false,
				timer: 5000
				// closeButtonHtml: `<button className=" btn btn-color w-25"> Close </button>` 
			})
		}
	  }
	  if(password == 'custom'){
		if(formData.get('password') === formData.get('cpassword')){
			process();
		}else{
			Swal.fire({
				title: 'Warning',
				icon:"warning",
				text: 'Password does not match confirm password.',
				// showCloseButton: true,
				showConfirmButton: false,
				timer: 5000
				// closeButtonHtml: `<button className=" btn btn-color w-25"> Close </button>` 
			})
			
		}
	  }else{
		process();
	  }
	//   window.stop_load();
    }
	const fetchPositions = async () => {
		const res = await getPositions();
		// console.log(res);
		if(res.success){
			setPositions(res.data);
		}
	}
	const fetchActiveUser = async () => {
		const res = await getActiveUser(localStorage.getItem('userId'));
		// console.log(res);
		if(res.success){
			setActiveUser(res.data);
		}
	}
	// const fetchUsersId = async () => {
	// 	const res = await getUsersId();
	// 	console.log(res);
	// 	if(res.success){
	// 		setAllUser(res.data);
	// 	}
	// } 
	useEffect(() => { 
		
		document.title = 'New Member | Taste Place Investment'
		fetchPositions();
	}, [])
	useEffect(() => {
		positions === null && fetchPositions();
	}, [data])
  return (
    <div className='m-1 px-2 py-5'
	style={{ 
		backgroundColor: 'whitesmoke',
		height: '99vh'
	 }}
	>
		<div className='d-flex justify-content-between mb-2'>
			<h4><b className=" mb-5"> New Staff </b></h4> 
		<button className='btn btn-md bg' onClick={()=>navigate('/new_user_id')}><b> Generate IDs</b></button>
		</div>
		
    	<Tabs variant='tabs' activeKey={defaultTab} onSelect={(k) => setDefaultTab(k)}>
			<Tab eventKey={'userDetails'} title={defaultTab !== 'userDetails' ? <h6> User Details <FaCheck /> </h6>  : 'User Details'} tabClassName='text-dark' disabled={defaultTab === 'userDetails' ? false : true}>
				<div className="card">
					<div className="card-body">
						<form action="" id="newUser"
						onSubmit={handleSubmit}
						>
						
							<div className="row">
								<div className="col-md-6 border-right">
									<b className="text-muted">Personal Information</b>
									{
										!imageStatus && 
										<div className='d-flex justify-content-center align-items-center'>
									<input type="file"  required
									onChange={(e) => {
										// console.log(e.target.files)
										// let media = [...newsImages.media,...e.target.files]
									setImage(e.target.files)
									setImageStatus(true)
										// dispatch(addProduct({media}))
									}}
									style={{display:"none"}} placeholder="Type here" name='file' className="form-control" id="uploadImages"
									/>
									<label  htmlFor='uploadImages' className='upload-images-label d-flex justify-content-center align-items-center' style={{
											display: "block",
											width: "90%",
											height:100,
											borderStyle:'dashed',
											borderColor:'GrayText',
											borderWidth:0.5,
											borderRadius:5,
										}
									}>
										<span style={{fontSize:12}}> Click to Add  Member Image</span>
									</label>
									</div>
									}
									{
										imageStatus && 
										<div className='products-container d-flex justify-content-start align-items-center m-2'>
										
													<div className='product-container d-flex-column mx-2 justify-content-center align-items-center' style={{
														cursor: "pointer",
														borderRadius:5,
														borderWidth:1,
														borderColor:"#e0e2e3",
											}} >
													<img
														src={ typeof(image[0]) === 'object' ? URL.createObjectURL(image[0]) : image}
														width={80}
														height={80}
													/>
													{/* <div className='delete-product d-flex justify-content-center align-items-center' style={{color:'#a50f0f'}} onClick={()=>{
														setNewsImages(newsImages.filter((_,ind)=> ind != index))
													}}>
														<i className="material-icons md-delete_forever"></i>
													</div> */}
													<DeleteForever
													className='d-flex justify-content-center align-self-center justify-contents-center'
													color='error'
													onClick={() => {
														setImageStatus(false)
														setImage('')
													}}
													/>
											</div>
										
									</div>
									}
									<div className="form-group">
										<label for="" className="control-label"> Full Name</label>
										<input
										onChange={handleChange}
										type="text" name="name" className="form-control form-control-sm" required />
									</div>
									<div className="form-group">
										<label className="control-label">Email</label>
										<input 
										onChange={handleChange}
										type="email" className="form-control form-control-sm" name="email" required />
										<small id="#msg"></small>
									</div>
									<div className="form-group">
										<label for="" className="control-label">Phone</label>
										<input 
										onChange={handleChange}
										type="text" name="phone" className="form-control form-control-sm" required />
									</div>
									<div className="form-group">
										<label className="control-label">Date of Birth</label>
										<input required
										onChange={handleChange}
										type="date" className="form-control form-control-sm" name="dob"/>
									</div>
									<div className="form-group">
										<label className="control-label">Highest Qualification </label>
										<Form.Select required
										onChange={handleChange}
										size='sm' name="qualification" id="qualification" className="form-control">
											<option value="" >Select Qualification ... </option>
											<option value="PHD" >PHD </option>
											<option value="MSC" >MSC</option>
											<option value="Degree" >BSC/BTECH/BENG/BED </option>
											<option value="HND" >HND</option>
											<option value="OND" >OND </option>
											<option value="NCE" >NCE</option>
											<option value="SSCE" >SSCE </option>
											<option value="JSCE" >JSCE</option>
											<option value="PSLC" >PSLC </option>
										</Form.Select>
									</div>
									<div className="form-group">
										<label className="control-label">Course of Study </label>
										<input required 
										onChange={handleChange}
										type="text" className="form-control form-control-sm" name="course" />
										
									</div>
								</div>
								<div className="col-md-6">
									<b className="text-muted">Other Details </b>
									<div className="form-group">
										<label className="control-label">Date of Employment</label>
										<input required
										onChange={handleChange}
										type="date" className="form-control form-control-sm" name="doe"/>
									</div>
									<div className="form-group">
										<label className="control-label">Origin</label>
										<div className='d-flex justify-content-between'>
											<div className='form-group'>
												<label className="control-label">State</label>
												<Form.Select required name='state' onChange={(e)=>{
													setLgas(JSON.parse(e.target.value).lgas)
													// console.log(e.target)
													setData({...data, state:JSON.parse(e.target.value).state})
												}}>
													<option> Select State...</option>
													{
														states.map((state, i) => 
														{

														// console.log(state)
														return(
															<option value={JSON.stringify(state)} key={i}
															> {state.state }</option>
														)})
													}
												</Form.Select>
											</div>
											<div className='form-group'>
												<label className="control-label">LGA</label>
												<Form.Select required name='lga' onChange={handleChange}>
													<option> Select LGA </option>
													{
														lgas && lgas.map((lga, i) => (
															<option value={lga} key={i}>{lga}</option>
														))
													}
												</Form.Select>
											</div>
										</div>
											
									</div>
									<div className="form-group">
										<label className="control-label">Residential Address </label>
										<input required 
										onChange={handleChange}
										type="text" className="form-control form-control-sm" name="address" />
										
									</div>
									<div className="form-group">
										<label className="control-label">Permanent Home Address </label>
										<input required 
										onChange={handleChange}
										type="text" className="form-control form-control-sm" name="permanent_address" />
										
									</div>
								<div className="form-group">
										<label for="" className="control-label">Gender</label>
										<Form.Select required
										onChange={handleChange}
										size='sm' name="gender" id="gender" className="form-control">
											<option value="" >Select Gender ... </option>
											<option value="male" >Male </option>
											<option value="female" >Female</option>
										</Form.Select>
										<small><i></i></small>
									</div>
									{/* <div className="form-group">
										<label for="" className="control-label">Select Department/Unit</label>
										<Form.Select 
										onChange={handleChange}
										size='sm' name="unit" id="unit" className="form-control">
											<option value="" >Select Member Unit... </option>
											<option value="Badminton" >Badminton</option>
											<option value="Gym" >Gym</option>
											<option value="Table Tennis"> Table Tennis </option>
											<option value="Tennis"> Tennis </option>
										</Form.Select>
										<small><i></i></small>
									</div> */}
									<div className="form-group">
										<label className="control-label">Position </label>
										<Form.Select required
										onChange={(e) => {
											let value = JSON.parse(e.target.value);
											setData({...data, position: value.title, 
												access_type: value.access_type, 
												category: value.category})
										}}
										size='sm' name="position" id="position" className="form-control"
										>
											<option value="" >Select Position ... </option>
											{
												positions && 
												positions.map((position, i) => (
													<option value={JSON.stringify(position)}  key={i}> {position.title}</option>
												))
											}
										</Form.Select>
									</div>
									<div className="form-group">
										<label className="control-label">Staff ID</label>
										<input disabled
										onChange={handleChange}
										type="text" className="form-control form-control-sm" name="staffID"/>
										
									</div>
									{/* <div className="form-group">
										<label for="" className="control-label">Account Status</label>
										<Form.Select 
										onChange={handleChange}
										size='sm' name="status" id="type" className="form-control">
											<option value="" >Select Status ... </option>
											<option value="1" >Active </option>
											<option value="0" >Disabled</option>
										</Form.Select>
										<small><i></i></small>
									</div> */}
									<div className="form-group">
									<b className="text-muted"> Select User Password Option </b>
										<select className='form-select'
										onChange={(e) => {
											setPassword(e.target.value);
											if(e.target.value === 'default'){
												setData({...data, password : '0000'})
											}
										}}
										>
											<option className='text-muted'
											style={{ 
												opacity: '60%'
											}}
											> Manage User Access Key... </option>
											<option value={'default'}> Use Default Password </option>
											<option value={'custom'}> Create a new password </option>
										</select>
										{password==='default' && <small className='text-muted'> Default password is 0000 </small>}
									</div>
									{ password === 'custom' &&
										<>
											<b className="text-muted">Create User Password </b>
											<div className="form-group">
												<label className="label control-label">Create Password</label>
												<input 
												onChange={handleChange}
												type="password" className="form-control form-control-sm" name="password" />
												<small id="pass_match" data-status=''></small>
											</div>
											<div className="form-group">
												<label className="label control-label">Confirm Password</label>
												<input 
												onChange={handleChange}
												type="password" className="form-control form-control-sm" name="cpassword" />
												<small id="pass_match" data-status=''></small>
											</div>	
										</>
									}
								</div>
								
							</div>
							<hr />
							<div className="col-lg-12 text-right justify-content-center d-flex">
								<button className="btn btn-danger btn-lg" type="button" 
								onClick={()=> {
									navigate('/users');
								}}
								style={{ width: '130px' }}
								>Cancel</button>
								<button
								type='submit'
								className="btn btn-color btn-lg ms-2"
								style={{ width: '130px' }}
								>Continue</button> 
							</div>
						</form>
					</div>
				</div>
			</Tab> 
			<Tab eventKey={'credentials'} title='User Credentials'   tabClassName='text-dark' disabled={defaultTab === 'credentials' ? false : true}> 
				
				<div className="card">
					<div className="card-body">
							<hr/>
							<h4 className='text-center text-muted'> Upload User Credential </h4>
							{ !activeUser ? fetchActiveUser : (
								<div className='d-flex justify-content-start'>
									<img src={activeUser.image} alt='Photo' width={50} height={50} />
									<h6> {activeUser.name} </h6>
								</div>
							) }
							<div className='row justify-content-center py-3'>
									<div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 col-12 form-group">
										{/* <label className="control-label"> </label> */}
										<select className='form-control form-control-md'
										value={docDetail.title} name='title'
										onChange={(e) => {
											// console.log(e.target.value);
											// docDetail.title = e.target.value;
											setDocDetail({...docDetail, title: e.target.value});
											// console.log(docDetail.title)
										}}
										>
											<option> Select Qualification...</option>
											<option value='phd'> PHD </option>
											<option value='msc'> MSC </option>
											<option value='pgd'> PGD </option>
											<option value='professional'> Professional Certificate </option>
											<option value='bsc'> BSC/BTech etc </option>
											<option value='hnd'> HND </option>
											<option value='nd'> ND </option>
											<option value='nce'> NCE </option>
											<option value='ssce'> SSCE </option>
											<option value='pslc'> PSLC </option>
										</select>
									</div>
									<div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 col-12 form-group">
										<div className='d-flex justify-content-center'>
											<input  id='docFile'
											// value={docFile}
											onChange={(e)=> {
												setDocFile(e.target.files);
												// console.log(userDocs);
											}}
											type="file" className="form-control form-control-md" name="file" />
											
										</div>
									
									</div>
									<div className='col-lg-6 col-md-6 col-12'>
											<div className='d-flex justify-content-center mt-2'>
												<input type='text' name='school' className='form-control' placeholder='enter school' 
												value={docDetail.school}
												onChange={(e) => {
													setDocDetail({...docDetail, school: e.target.value})
													// console.log(docDetail.school)
												}}
												/>
												<button 
												type='button'
												onClick={()=> {
													let docF = document.getElementById('docFile');
													// console.log(docDetail);
													setUserDocs([...userDocs, {title: docDetail.title, school: docDetail.school, file: docFile} ])
													// console.log(docF.value);
													docF.value = '';
													setDocDetail({title: '', school: ''});
													setDocFile();
												}}
												className='add-btn ms-2 form-control form-control-md btn-color'> 
													Add <FaPlus />
												</button>
											</div>
									</div>
							</div>
							<div>
								<table className='table responsive'>
									<thead>
										<tr>
											<th>School/Qualification</th>
											<th>Document</th>
											<th>Action</th>
										</tr>
									</thead>
									<tbody>
										{
										userDocs.length !== 0 && userDocs.map((docs, i) => (
											<tr> 
												<td>
													{docs.school + '/' + docs.title}
												</td>
												<td>
													 {docs.file[0].name}
												</td>
												<td><button onClick={()=> setUserDocs(userDocs.filter((d, index) => index !== i ))} className='btn btn-md btn-danger'>Remove</button></td>
												{/* {console.log(docs)} */}
												 {/* <object data={URL.createObjectURL(docs.file)} type="application/pdf" width="50px" height="50px">
													<p>Alternative text - include a link <a href={URL.createObjectURL(docs.file)}>to the PDF!</a></p>
												</object> */}
											</tr>
										))
									}
									</tbody>
								</table>
								{/* <ul>
									<li>Testing List </li>
									
								</ul> */}
							</div>
						<div className="col-lg-12 text-right justify-content-center d-flex">
								<button className="btn btn-danger btn-lg" type="button" 
								onClick={()=> {
									navigate('/users');
								}}
								style={{ width: '120px' }}
								>
									Close
								</button>
								<button 
								className="btn btn-color btn-lg ms-2"
								style={{ width: '120px' }}
								onClick={()=>{
									Swal.fire({
										// title: '<u>Create New Inventory</u>',
										html: `<h5 style='color:red'> This feature is not yet activated.</h5>`,
										icon: 'error',
										confirmButtonText: `Close`,
										confirmButtonColor: 'red',
										showCloseButton: true,
										confirmButtonAriaLabel: 'ests'
										// close
						
									});
								}}
								>
									Submit
								</button> 
						</div>
					</div>
				</div>
			</Tab>
			{/* <Tab eventKey={'preview'} title='Preview'  tabClassName='text-dark' disabled={true}>

			</Tab> */}
		</Tabs>
		{/* </form> */}
    </div>
  )
}

export default CreateUser